<template>
    <div v-if="!loading" class="estimator">
        <form method="POST" @submit.prevent="btnCreateShipment()">
            <div class="estimate" id="estimate">
                {{ $t('estimate') }}
            </div>
            <div class="preview">
                <div class="row">
                    <div class="col-md-6 text-center">
                        <span class="height">{{ sizing.height }}</span>
                        <img id="previewImg" v-bind:src="sizeImage" class=invert />
                        <span class="width">{{ sizing.width }}</span> x
                        <span class="length">{{ sizing.length }}</span>
                    </div>
                    <div class="col-md-6 text-center">
                        <h2>
                            {{ priceEstimate }}
                        </h2>
                    </div>
                </div>
            </div>
            <div class="mt-3">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" id="shipment-tab" data-toggle="tab" href="#shipment" role="tab"
                            aria-controls="shipment" aria-selected="true">
                            {{ $t('shipment.title') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="pickup-tab" data-toggle="tab" href="#pickup" role="tab"
                            aria-controls="pickup" aria-selected="false">
                            {{ $t('pickup.title') }}
                        </a>
                    </li>
                    <li class="nav-item" symbol>
                        <a class="nav-link" id="destination-tab" data-toggle="tab" href="#destination" role="tab"
                            aria-controls="destination" aria-selected="false">
                            {{ $t('destination.title') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="details-tab" data-toggle="tab" href="#details" role="tab"
                            aria-controls="details" aria-selected="false">
                            {{ $t('delivery.title') }}
                        </a>
                    </li>
                </ul>
            </div>

            <div class="tab-content pb-4" id="myTabContent">
                <div class="tab-pane active" id="shipment" role="tabpanel" aria-labelledby="shipment-tab">
                    <div class="form-row mb-4">
                        <div class="col-md-4">
                            <label for="inputSize">{{ $t('shipment.size') }}</label>
                            <select v-model="shipment.size" id="inputSize" class="form-control">
                                <option v-for="(size, index) in sizes" v-bind:key="index" v-bind:value="index">
                                    {{ $t('sizes.' + index) }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label for="inputWeight">{{ $t('shipment.weight') }}</label>
                            <select v-model="shipment.weight" id="inputWeight" class="form-control">
                                <option v-for="(weight, index) in weights" v-bind:key="index" v-bind:value="index">
                                    {{ $t('weights.' + index) }} ({{ weight.kg }})
                                </option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label for="inputSpeed">{{ $t('shipment.shipmentSpeed') }}</label>
                            <select v-model="shipment.speed" id="inputSpeed" class="form-control">
                                <option v-for="speed in speeds" v-bind:key="speed" v-bind:value="speed">
                                    {{ $t('speeds.' + speed) }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="form-row mb-4 text-right">
                        <button type="button" v-on:click="btnShowPickup" class="btn btn-primary">
                            Next Step
                        </button>
                    </div>
                </div>

                <div class="tab-pane" id="pickup" role="tabpanel" aria-labelledby="pickup-tab">
                    <div class="mb-5">
                        <div class="form-row">
                            <div class="form-group col-md-5">
                                <label for="inputName">
                                    {{ $t('pickup.name') }}
                                </label>
                                <input type="text" v-model="pickup.name" class="form-control" id="inputName" />
                            </div>
                            <div class="form-group col-md-3">
                                <label for="inputMethod">
                                    {{ $t('pickup.contactMethod') }}
                                </label>
                                <select id="inputMethod" class="form-control" v-model="pickup.method">
                                    <option value="none">None</option>
                                    <option value="sms">SMS</option>
                                    <option value="voice">Phone Call</option>
                                    <option value="email">Email</option>
                                    <option value="signal">Signal</option>
                                    <option value="telegram">Telegram</option>
                                    <option value="whatsapp">WhatsApp</option>
                                    <option value="wire">Wire</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="inputContact">
                                    {{ $t('pickup.contact') }}
                                </label>
                                <input type="text" v-model="pickup.contact" class="form-control" id="inputContact" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputAddressStart">
                                    {{ $t('pickup.address') }}
                                </label>
                                <input type="text" class="form-control" v-model="pickup.address" id="inputAddressStart"
                                    placeholder="1234 Main St" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputAddress2Start">
                                    {{ $t('pickup.addressSuffix') }}
                                </label>
                                <input type="text" class="form-control" v-model="pickup.address2"
                                    id="inputAddress2Start" placeholder="Apartment, studio, or floor" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputCityStart">{{ $t('pickup.city') }}</label>
                                <input type="text" class="form-control" v-model="pickup.city" id="inputCityStart" />
                            </div>
                            <div class="form-group col-md-2">
                                <label for="inputZipStart">{{ $t('pickup.postal') }}</label>
                                <input type="text" class="form-control" id="inputZipStart" v-model="pickup.postal" />
                            </div>
                            <div class="form-group col-md-4">
                                <label for="inputStateStart">{{ $t('pickup.state') }}</label>
                                <select id="inputStateStart" class="form-control" v-model="pickup.state">
                                    <option v-for="country in $tm('countries')" :key="country.value"
                                        v-bind:value="country.value">
                                        {{ country.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <button type="button" v-on:click="btnShowDestination" class="btn btn-primary float-right">
                            Next Step
                        </button>
                    </div>
                </div>

                <div class="tab-pane" id="destination" role="tabpanel" aria-labelledby="destination-tab">
                    <div class="mb-5">
                        <div class="form-row">
                            <div class="form-group col-md-5">
                                <label for="inputNameEnd">{{ $t('destination.name') }}</label>
                                <input type="text" class="form-control" id="inputNameEnd" v-model="destination.name" />
                            </div>
                            <div class="form-group col-md-3">
                                <label for="inputMethodEnd">{{ $t('destination.contactMethod') }}</label>
                                <select id="inputMethodEnd" class="form-control" v-model="destination.method">
                                    <option value="none" selected>None</option>
                                    <option value="sms">SMS</option>
                                    <option value="voice">Phone Call</option>
                                    <option value="day">Email</option>
                                    <option value="signal">Signal</option>
                                    <option value="telegram">Telegram</option>
                                    <option value="whatsapp">WhatsApp</option>
                                    <option value="wire">Wire</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="inputContactEnd">
                                    {{ $t('destination.contact') }}
                                </label>
                                <input type="text" class="form-control" id="inputContactEnd"
                                    v-model="destination.contact" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputAddressEnd">
                                    {{ $t('destination.address') }}
                                </label>
                                <input type="text" class="form-control" id="inputAddressEnd" placeholder="1234 Main St"
                                    v-model="destination.address" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputAddress2End">
                                    {{ $t('destination.addressSuffix') }}
                                </label>
                                <input type="text" class="form-control" id="inputAddress2End"
                                    placeholder="Apartment, studio, or floor" v-model="destination.address2" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputCityEnd">
                                    {{ $t('destination.city') }}
                                </label>
                                <input type="text" class="form-control" id="inputCityEnd" v-model="destination.city" />
                            </div>
                            <div class="form-group col-md-2">
                                <label for="inputZipEnd">
                                    {{ $t('destination.postal') }}
                                </label>
                                <input type="text" class="form-control" id="inputZipEnd" v-model="destination.postal" />
                            </div>
                            <div class="form-group col-md-4">
                                <label for="inputStateEnd">
                                    {{ $t('destination.state') }}
                                </label>
                                <select id="inputStateEnd" class="form-control" v-model="destination.state">
                                    <option v-for="country in $tm('countries')" :key="country.value"
                                        v-bind:value="country.value">
                                        {{ country.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <button type="button" v-on:click="btnShowDetails" class="btn btn-primary float-right">
                            Next Step
                        </button>
                    </div>
                </div>

                <div class="tab-pane" id="details" role="tabpanel" aria-labelledby="details-tab">
                    <h4>{{ $t('delivery.payment') }}</h4>
                    <div class="form-row mb-3">
                        <div class="form-group col-md-6">
                            <label for="inputPayment">
                                {{ $t('delivery.paymentMethod') }}
                            </label>
                            <select id="inputPayment" class="form-control" v-model="details.payment">
                                <option value="none" selected>None</option>
                                <option value="cash">Cash</option>
                                <option value="bitcoin">Bitcoin</option>
                                <option value="paypal">PayPal</option>
                                <option value="cc">Credit Card</option>
                                <option value="time">Time Bank</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label for="payer">{{ $t('delivery.paymentPayer') }}</label>
                            <select id="payer" class="form-control" v-model="details.payer">
                                <option value="na">Not Applicable</option>
                                <option value="sender">Sender</option>
                                <option value="receiver">Receiver</option>
                            </select>
                        </div>
                    </div>
                    <h5>{{ $t('delivery.tos') }}</h5>
                    <div v-html="$t('delivery.tosMust')"></div>
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" v-model="agree" type="checkbox" id="gridCheck" />
                            <label class="form-check-label" for="gridCheck">
                                {{ $t('delivery.tosAgree') }}
                            </label>
                        </div>
                    </div>
                    <div class="mb-3">
                        <button type="button" class="btn btn-secondary mr-4" @click="btnCancelShipment()">
                            {{ $t('delivery.btnCancel') }}
                        </button>
                        <button type="submit" class="btn btn-primary" @submit.prevent="btnCreateShipment()">
                            {{ $t('delivery.btnComplete') }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import $ from 'jquery'

import { ssr, ssrFetcher } from '@eotl/simple-signed-records'

import sizes from '@/enums/Sizes'
import currency from '@/enums/Currency'
import weights from '@/enums/Weights'
import { cargoUtils, friendlyId } from '@/composables'
import { useEotlCore } from '@/store'

export default {
    data() {
        const store = useEotlCore()

        return {
            store,
            currency: currency.eur,
            sizing: sizes.md,
            sizes: sizes,
            weights: weights,
            speeds: ['immediate', 'day', 'next', 'second', 'week'],
            loading: true,
            shipment: {
                size: 'md',
                weight: 'average',
                speed: 'next',
            },
            details: {
                payment: 'cash',
                payer: 'receiver',
            },
            agree: false,
        }
    },
    computed: {
        sizeImage() {
            return `/images/icons/box-${this.shipment.size}.svg`
        },
        priceEstimate() {
            return cargoUtils.tallyFee(this.shipment, currency['eur'].symbol)
        },
        pickup() {
            const { city, country, postal } = this.store.config

            return {
                name: '',
                method: 'none',
                contact: '',
                address: '',
                address2: '',
                city,
                state: country,
                postal,
            }
        },
        destination() {
            const { city, country, postal } = this.store.config

            return {
                name: '',
                method: 'none',
                contact: '',
                address: '',
                address2: '',
                city,
                state: country,
                postal,
            }
        },
    },
    methods: {
        btnShowShipment() {
            $('#shipment-tab').tab('show')
        },
        btnShowPickup() {
            $('#pickup-tab').tab('show')
        },
        btnShowDestination() {
            $('#destination-tab').tab('show')
        },
        btnShowDetails() {
            $('#details-tab').tab('show')
        },
        btnCreateShipment() {
            const record = {
                size: this.shipment.size,
                weight: this.shipment.weight,
                speed: this.shipment.speed,
                pickup_name: this.pickup.name,
                pickup_method: this.pickup.method,
                pickup_contact: this.pickup.contact,
                pickup_address: this.pickup.address,
                pickup_address2: this.pickup.address2,
                pickup_city: this.pickup.city,
                pickup_state: this.pickup.state,
                pickup_postal: this.pickup.postal,
                dest_name: this.destination.name,
                dest_method: this.destination.method,
                dest_contact: this.destination.contact,
                dest_address: this.destination.address,
                dest_address2: this.destination.address2,
                dest_city: this.destination.city,
                dest_state: this.destination.state,
                dest_postal: this.destination.postal,
            }

            const router = this.$router
            ssrFetcher.Post('shipments', record).then((data) => {
                router.push('/shipment/' + data.id)
            })
        },
        btnCancelShipment() {
            alert('Cancel order to be created...')
        }
    },
    mounted() {
        this.loading = false
    },
}
</script>

<style>
.estimator {
    max-width: 1000px;
}

.estimator .estimate {
    background-color: #fffb77;
    border-radius: .75rem;
    font-size: 0.85rem;
    padding: .25rem .75rem;
    color: #444444;
    display: inline-block;
    margin: 0 auto;
    position: relative;
    top: 15px;
    left: 10px;
}

.estimator .preview {
    background-color: var(--box-bg-color);
    margin-bottom: 2.5rem;
    padding-bottom: 1.5rem;
    font-family: 'Roboto-Light', serif;
}

.estimator .preview h2 {
    padding: 4rem 1rem 2rem 1rem;
    color: var(--main-fg-color);
    font-size: 4.5rem;
    border-radius: 1rem;
}

@media (prefers-color-scheme: dark) {
    .estimator .preview img {
        /* might bring back later
        filter: invert(100%);
         */
    }
}

.estimator #account-tab img {
    height: 20px;
}

.estimator #account-tab.active img {
    filter: invert(1)
}

.estimator #gridCheck:checked {
    background: green;
}

.estimator .form-control {
    background-color: var(--form-bg-color) !important;
}
</style>
